/* global euAdminConfig */

const getUserDetails = (username, userStatus, callback) => {
    const withForwards = ['open', 'trial'].includes(userStatus);

    (async () => {
        let response;

        try {
            response = await fetch(
                `${euAdminConfig.base_uri + euAdminConfig.hostname}/users/${username}/details?withForwards=${withForwards}`,
                {
                    method: 'GET',
                    credentials: 'include'
                }
            );
        } catch (error) {
            return;
        }

        if (!response.ok) {
            return;
        }

        callback(await response.json());
    })();
};

export default getUserDetails;
